import { FC } from 'react';

import { CrossOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import { AdfoxCloseButtonColor } from 'components/Admin/AdfoxInfo/adfoxInfoModel';

import styles from 'components/Admin/AdfoxInfo/PromoFields/FullScreenStyleFields/preview.module.less';

interface CloseButtonPreviewProps {
    option: AdfoxCloseButtonColor;
}

export const CloseButtonPreview: FC<CloseButtonPreviewProps> = ({ option }) => {
    const isLightCross = option === AdfoxCloseButtonColor.Light;

    return (
        <div
            className={isLightCross ? styles.previewDark : styles.previewLight}
            data-qa={`adfox-info-close-color-preview-${option}`}
        >
            <CrossOutlinedSize24 initialColor={isLightCross ? 'contrast' : 'primary'} />
        </div>
    );
};
